import { useTranslation } from 'react-i18next'
import notFoundImage from '@/assets/store-unavailable-graphic.png'

export default function StoreNotAvailable() {
  const { t } = useTranslation()

  return (
    <div className="fixed inset-0 z-9999 flex flex-col items-center justify-center bg-[#1A1A1A] px-6">
      <img
        src={notFoundImage}
        alt={t('storeUnavailable.imageAlt')}
        className="max-w-md w-full h-auto object-contain"
        width={800}
        height={800}
        loading="lazy"
      />
      <h2 className="mt-8 text-2xl font-bold text-white text-center">
        {t('storeUnavailable.title')}
      </h2>
      <p className="mt-3 text-base text-white/80 text-center">{t('storeUnavailable.subtitle')}</p>
    </div>
  )
}
